import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { HelpCenterTypes, helpCenterTypesValues } from '../definitions/help-center.enum';
import { CustomerModuleKey } from '../models/customer';
import { CustomerService } from './customer.service';

export const helpCategoryGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const customerService = inject(CustomerService);
  let helpCategory = (route.data?.['option'] as string | undefined) ?? route.params.option;

  if (!helpCenterTypesValues.includes(helpCategory)) {
    return router.parseUrl('/help-center');
  }

  if (
    !customerService.isCustomerModuleEnabled(CustomerModuleKey.PAYMENT_MANAGEMENT) &&
    helpCategory === HelpCenterTypes.InvoicesAndPayments
  ) {
    helpCategory = HelpCenterTypes.Tutorship;
  }

  return true;
};
